import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { requireCoachAuth } from "~/lib/coach-middleware";
import { getCoach } from "~/lib/server/coach";
// Defer Stripe to runtime
import { createNoIndexMeta } from "~/lib/shared/meta";

export const getStripeAccount = createServerFn({ method: "GET" })
  .middleware([requireCoachAuth])
  .validator(z.object({ coachId: z.string() }))
  .handler(async ({ data }) => {
    const coach = await getCoach(data.coachId);
    if (coach?.stripeAccountId) {
      const { getStripe } = await import("~/lib/stripe");
      const stripe = await getStripe();
      const account = await stripe.accounts.retrieve(coach.stripeAccountId);
      return { account, coach };
    }

    return { coach };
  });

function StripeAccountPage() {
  const { coachId } = Route.useSearch();

  const { data } = useQuery({
    queryKey: ["stripe-account", coachId],
    queryFn: () => getStripeAccount({ data: { coachId } }),
    enabled: !!coachId,
  });

  const { account, coach } = data || {};

  return (
    <div>
      <h1>Stripe Account</h1>
      <pre>{JSON.stringify(account, null, 2)}</pre>
      <pre>{JSON.stringify(coach, null, 2)}</pre>
    </div>
  );
}

export const Route = createFileRoute("/admin/stripe/")({
  head: () =>
    createNoIndexMeta(
      "Admin - Stripe Account – Dream Coach Match",
      "Admin view of coach Stripe account information",
    ),
  validateSearch: z.object({
    coachId: z.string(),
  }),
  loader: async ({ context, location }) => {
    const search = location.search as { coachId: string };
    await context.queryClient.ensureQueryData({
      queryKey: ["stripe-account", search.coachId],
      queryFn: () => getStripeAccount({ data: { coachId: search.coachId } }),
    });
    return {};
  },
  component: StripeAccountPage,
});
